<template>
  <div id="Kits" class="container">
    <div v-if="areKitsLoading && disableLoadingSpinner === false">
      <loading-spinner />
    </div>
    <div v-else-if="!areKitsLoading && IsNotNullOrUndefined(kits) && kits.length > 0">
      <b-form id="kitForm">
        <b-form-group>
          <b-row v-for="kit in kits" :key="kit.KitName" class="kit-row">
            <h2 class="kit-title">
              {{ kit.KitName }}
            </h2>
            <dn-table
              class="blue"
              :items="kit.KitParts"
              :fields="kitDataColumns"
              :busy="areKitsLoading"
              :show-pagination="false"
              :use-pagination="false"
            >
              <template #SuggestedQuantity="{ row }">
                <span v-if="row.item.SuggestedQuantity == 0"> As Needed </span>
                <span v-else>
                  {{ row.item.SuggestedQuantity }}
                </span>
              </template>
              <template #OemPartCode="{ row }">
                <router-link :to="{ name: 'PartDetails', query: { oemPartCode: row.item.OemPartCode } }">
                  {{ row.item.OemPartCode }}
                </router-link>
              </template>
              <template #Notes="{ row }">
                {{ row.item.Notes }}
              </template>
              <template #Quantity="{ row }">
                <dn-number-input
                  :id="row.item.Id.toString()"
                  v-model="row.item.Quantity"
                  name="kitItemQuantity"
                  :allow-negatives="false"
                  :min-number="0"
                />
              </template>
            </dn-table>
          </b-row>
        </b-form-group>
        <b-row class="pull-right kit-row">
          <div class="col-xs-4">
            <dn-function-button
              button-id="clearFormBtn"
              :callback-fn="ClearForm"
              text="Clear Form"
              :loading="clearingForm"
            />
          </div>
          <b-col />
          <div class="col-xs-6">
            <dn-function-button
              button-id="submitFormBtn"
              :callback-fn="SubmitForm"
              text="Add To Cart"
              :size="largeSize"
              :loading="addingItemsToCart"
            />
          </div>
        </b-row>
      </b-form>
    </div>
  </div>
</template>
<script>
import DnFunctionButton from "@/components/Elements/DnFunctionButton";
import { sizeHelper } from "@/components/mixins/sizeHelper";
import DnNumberInput from "@/components/Elements/DnNumberInput";
import { ShoppingCartService } from "@/services/ShoppingCartService";
import { mapGetters } from "vuex";
import { CatalogService } from "@/services/CatalogService";
import { ErrorLogService } from "@/services/ErrorLogService";
import LoadingSpinner from "@/components/Elements/LoadingSpinner";
import DnTable from "@/components/Elements/DnTable/DnTable.vue"

export default {
  components: {
    DnNumberInput,
    DnFunctionButton,
    LoadingSpinner,
    DnTable,
  },
  mixins: [sizeHelper],
  props: {
    categoryId: {
      default: 0,
    },
    disableLoadingSpinner: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    kitDataColumns: [
      { key: "OemPartCode", label: "Part Number" },
      { key: "Description", label: "Description" },
      { key: "Notes", label: "Notes", thClass: "notes" },
      { key: "SuggestedQuantity", label: "Suggested Qty", tdClass: "suggested-quantity" },
      { key: "Quantity", label: "Quantity", thClass: "quantity" },
    ],
    clearingForm: false,
    addingItemsToCart: false,
    kits: [],
    areKitsLoading: false,
  }),
  computed: {
    ...mapGetters(["user", "activeAccountId", "cartSummary"]),
  },
  created() {
    this.LoadKits();
  },
  methods: {
    ClearForm() {
      this.clearingForm = true;
      event.preventDefault;
      this.SetAllPartQuanitiesToZero();
      document.getElementById("kitForm").reset();
      this.clearingForm = false;
    },
    SubmitForm() {
      this.addingItemsToCart = true;
      let kitParts = this.kits.flatMap((kit) => kit.KitParts);
      let partsWithQuantities = kitParts.filter((part) => part.Quantity !== 0);

      if (this.IsNotNullOrUndefined(partsWithQuantities) && partsWithQuantities.length < 1) {
        this.$store.commit("pushTimedMessage", {
          header: "Please enter a quantity for at least one part.",
          IsError: true,
          sticky: true,
        });
      }

      let partOemPartCodesAndQuantities = {};

      partsWithQuantities.forEach(function (part) {
        partOemPartCodesAndQuantities[part.OemPartCode] = part.Quantity;
      });

      const accountContext = {
        accountId: this.activeAccountId,
        userId: this.user.UserId,
      };

      const request = {
        ...accountContext,
        shoppingCartId: this.cartSummary.Id,
        partOemPartCodesAndQuantities,
      };

      ShoppingCartService.AddShoppingCartItems(request)
        .then((result) => {
          this.$store.dispatch("LOAD_CART_SUMMARY", accountContext);
          this.$store.commit("pushTimedMessage", {
            header: "Items Added to cart successfully",
            IsError: false,
            seconds: 15,
          });
          this.ClearForm();
        })
        .catch((err) => {
          this.$store.commit("pushTimedMessage", {
            header: "Error adding items to cart",
            IsError: true,
            seconds: 15,
          });
        })
        .finally(() => {
          this.addingItemsToCart = false;
          window.scrollTo(0, 0);
        });
    },
    SetAllPartQuanitiesToZero() {
      var self = this;

      if (self.IsNotNullOrUndefined(self, "kits")) {
        self.kits.forEach(function (kit, i) {
          kit.KitParts.forEach(function (kitPart, j) {
            self.kits[i].KitParts[j].Quantity = 0;
          });
        });
      }
    },
    LoadKits() {
      var self = this;
      this.areKitsLoading = true;
      CatalogService.GetKits(this.activeAccountId, this.user.UserId, this.categoryId)
        .then((kitResult) => {
          self.kits = kitResult.data === "" ? null : kitResult.data;
        })
        .catch((err) => {
          ErrorLogService.LogException(error);
        })
        .finally(() => {
          self.areKitsLoading = false;
          self.SetAllPartQuanitiesToZero();
          self.$emit("loaded");
        });
    },
  },
};
</script>

<style lang="scss">
.kit-title {
  font-size: 16px;
}
.notes {
  width: 200px;
}
.suggested-quantity {
  text-align: right;
  line-height: 36px;
}
.quantity {
  width: 100px;
}
#Kits {
  .kit-row {
    margin-left: 0;
    margin-right: 0;
  }
}
</style>
